module.exports = __webpack_public_path__ + "static/media/full_stack_development.e280210b.svg";